export const validateMaxFileSize = (maxSizeInMB: number = 15) => (value: any) => {
    if (!value) return undefined;
    
    // For single File/FileInput in React Admin (it has a rawFile property)
    const file = value.rawFile || value;
    if (file && file.size && file.size > maxSizeInMB * 1024 * 1024) {
        return `El archivo supera el límite máximo permitido de ${maxSizeInMB} MB.`;
    }
    
    // For multiple FileInput in React Admin (it is an array of files)
    if (Array.isArray(value)) {
        for (const item of value) {
            const f = item.rawFile || item;
            if (f && f.size && f.size > maxSizeInMB * 1024 * 1024) {
                return `Uno de los archivos supera el límite máximo permitido de ${maxSizeInMB} MB.`;
            }
        }
    }
    
    return undefined;
};
